import { supabase } from '@/lib/supabase'
import type { UserListItem } from '../types'

export async function fetchUsersList(): Promise<UserListItem[]> {
  const { data, error } = await supabase
    .from('user_list')
    .select('*')
    .order('profile_created_at', { ascending: false })

  if (error) throw error
  return data as UserListItem[]
}
